import React from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import CommonTable from '../../Admin/components/Common_table'
import Addcatalogue from '../components/Add_catalogue'
import { useGlobalContext } from '../../context/Context'
import SubHeader from '../components/SubHeader'
import PageFilter from '../components/PageFilter'

const ProductSubcategory = () => {

  const data = {
    "columns": [
      {
        "label": "S.No",
        "field": "sno",
      },
      {
        "label": "Sub-Category",
        "field": "sub-category",
      },
      {
        "label": "Sub-Sub-Category",
        "field": "sub-sub-category",
      },
      {
        "label": "no of views",
        "field": "views",
      },
      {
        "label": "Design Type",
        "field": "design",
      },
      {
        "label": "Design Pic",
        "field": "pic",
      },
      {
        "label": "Upload Date",
        "field": "date",
      },
      {
        "label": "Actions",
        "field": "action",
      },
    ],
    "rows": [
      {
        "sno": "1",
        "sub-category": "Blazer",
        "sub-sub-category": "Blazer",
        "views": 7,
        "design": "Blazer Suit",
        "pic": "https://imgs.search.brave.com/gogBDxI-sk28bdhJhTOmNrZ7o7JnTq3KuQ9SGA8Oej4/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tLm1l/ZGlhLWFtYXpvbi5j/b20vaW1hZ2VzL0kv/NDF0cTRZQjNZU0wu/X0FDLl9TUjE4MCwy/MzAuanBn",
        "date": "11/8/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "2",
        "sub-category": "Kurta",
        "sub-sub-category": "Kurta Pyjama",
        "views": 5,
        "design": "Kurta",
        "pic": "https://imgs.search.brave.com/jDZCxSbiNdrqkA39bn_JylxzVmsuktfu7sGpOLSHRZw/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWFn/ZXMuY2JhemFhci5j/b20vaW1hZ2VzL21l/bnMtdHVycXVvaXNl/LXNpbGstamFjcXVh/cmQtYnJvY2FkZS1r/dXJ0YS1weWphbWEt/c2V0LWtwbXNjMzE5/Ni11LmpwZw",
        "date": "11/8/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "3",
        "sub-category": "Dhoti",
        "sub-sub-category": "Coat",
        "views": 3,
        "design": "Suit",
        "pic": "https://imgs.search.brave.com/umGLg7YvhcYIuuPzMjP4tv-nYcczn2LufZa3rufrPuo/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvMTIx/NTc2NzA3MS9waG90/by9wb3J0cmFpdC15/b3VuZy1oYXBweS1z/b3V0aC1pbmRpYW4t/bWFuLXN0b2NrLXBo/b3RvLmpwZz9zPTYx/Mng2MTImdz0wJms9/MjAmYz16NWdQbkxq/d3dTdU1MZHoyOEx3/REM1c19LbUtQX2Ri/RWZrd2o1Mnduc3ZF/PQ",
        "date": "11/8/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "4",
        "sub-category": "Trouser",
        "sub-sub-category": "Trouser",
        "views": 4,
        "design": "Trouser",
        "pic": "https://imgs.search.brave.com/OTEm9gRA6kjGjofiaEDZhiLjMIGPouhzg4CRH9jFWnk/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5ncS1tYWdhemlu/ZS5jby51ay9waG90/b3MvNjZmNmFiOGRm/NGRlNTNhNTk0YTMy/NGM4LzM6NC93XzMy/MCxjX2xpbWl0L0Jl/c3QtVHJvdXNlcnMt/Zm9yLW1lbi1Nci1Q/LVRhcGVyZWQtcGxl/YXRlZC1Ud2lsbC1U/cm91c2Vycy5qcGc",
        "date": "11/8/2024",
        "action": "11/7/2024",
        "status": true
      },
      {
        "sno": "5",
        "sub-category": "Patiala",
        "sub-sub-category": "Patiala",
        "views": 9,
        "design": "Trouser",
        "pic": "https://imgs.search.brave.com/6aNKE7EsgdMK_8rCJpDE8yNIm0wrvVDp-DIM9i_d-1A/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzRjLzg5/L2VmLzRjODllZjlj/OTAwZTc3MTE0ODk5/NjJlYTM0YWMyOWUx/LmpwZw",
        "date": "11/8/2024",
        "action": "11/7/2024",
        "status": true
      },
    ]
  }

  const filterOptions = ["All", "Recently Added"];
  const { openDialog, setOpenDialog } = useGlobalContext();
  const title = { name: "Blazer/Sub-categories", subheading: "Add to the catalogue and view products", search: "Search products", button: "Add Products" }

  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader title={title} openDialog={openDialog} setOpenDialog={setOpenDialog} />
        <SubHeader menu={'sub-category'} sort={'sub-category'} options={filterOptions} />
        <CommonTable columns={data.columns} rows={data.rows} />
        <PageFilter />
        <Addcatalogue openDialog={openDialog} setOpenDialog={setOpenDialog} />
      </section>
    </>
  )
}

export default ProductSubcategory
